import { IPublicBlogPost } from '@/infrastructure/interfaces/i-blog';
import { getBlogImageUrl, getBlogPostPath } from '@/infrastructure/blog/urls';
import { stripTrailingSlash } from '@/utils/helpers/strip-trailing-slash';

const blogPostMarkupSchema = (post: IPublicBlogPost, description: string) => {
  const siteUrl = stripTrailingSlash(process.env.NEXT_PUBLIC_SITE_URL || '');
  const image = getBlogImageUrl(post.heroImage);

  return {
    '@type': 'Article',
    '@id': `${siteUrl}${getBlogPostPath(post.slug)}#article`,
    headline: post.title,
    description,
    inLanguage: post.language || 'en',
    mainEntityOfPage: `${siteUrl}${getBlogPostPath(post.slug)}`,
    ...(image ? { image } : {}),
    ...(post.publishedAt ? { datePublished: post.publishedAt } : {}),
    dateModified: post.updatedAt,
    author: {
      '@type': 'Organization',
      name: 'Quran Pro',
      '@id': `${siteUrl}/#organization`,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Quran Pro',
      '@id': `${siteUrl}/#organization`,
    },
  };
};

export default blogPostMarkupSchema;
